export default __webpack_public_path__ + "static/0051-e2c088adf00a6a1df8b47d4af7c0fd3c.png";